import {LoaderFunctionArgs, redirect} from 'react-router';
import {getDebugSettings} from '@/components/document/hooks/use-debug-settings';
import {resolveDebugModelVersion} from '@/components/document/model-version/resolve-debug-model-version';
import {APP_PATH} from '@/constants/routes';
import {loadConfiguration} from '@/contexts/config/config.loader';
import environment from '@/environment';
import {logger} from '@/initializers/logger';
import {getAll as getAllAllocations} from '@/repositories/beneva-api/endpoints/allocations';
import {getById as getDocumentById, getDocumentAttachments} from '@/repositories/beneva-api/endpoints/documents';

const DOCUMENT_STATUS_WHERE_USER_CANNOT_EDIT = ['waitingSubmit', 'sent'];

export const FormLoader = async ({params}: LoaderFunctionArgs) => {
  if (!params.formId) return redirect(APP_PATH);

  try {
    const {data: document} = await getDocumentById(params.formId);
    const {data: attachments} = await getDocumentAttachments(params.formId);
    const {data: allocations} = await getAllAllocations();
    const documentConfig = await loadConfiguration(document.modelVersion);

    if (!document || DOCUMENT_STATUS_WHERE_USER_CANNOT_EDIT.includes(document.status)) {
      return redirect(APP_PATH);
    }

    const debugOverrideVersion = resolveDebugModelVersion(getDebugSettings().debugModelVersion);
    const needsDebugFetch = Boolean(
      environment.DEBUG &&
        debugOverrideVersion &&
        document.status === 'incomplete' &&
        debugOverrideVersion !== documentConfig.version,
    );
    const debugOverrideConfig = needsDebugFetch ? await loadConfiguration(debugOverrideVersion as string) : undefined;

    return {
      documentConfig,
      debugOverrideVersion,
      debugOverrideConfig,
      document: document,
      allocations: allocations,
      attachments: attachments,
    };
  } catch (error) {
    logger.error('Error loading form data:', error);
    return redirect('/not-found');
  }
};
